import React from "react";
import FilterGroup from "../../common/reports/FilterGroup";
import FilterItem from "../../common/reports/FilterItem";
import Button from "../../framework/Button";
import Shortcut from "../../framework/Shortcut";
import classes from "./RetailerReportsSummary.module.css";

const RetailerReportsSummary = ({
  defaultConfig = () => {},
  refreshData = () => {},
  quickExport = () => {},
}) => {
  return (
    <div className={classes["summary-container"]}>
      <div className={classes["summary-ctas"]}>
        <FilterGroup>
          {/* <FilterItem>
            <Button
              label="Default Configuration"
              color="violet"
              onClick={defaultConfig}
              endIcon={<Shortcut keys={["Alt", "C"]} />}
            />
          </FilterItem> */}
          <FilterItem>
            <Button
              label="Quick Export"
              color="black"
              onClick={quickExport}
              endIcon={<Shortcut keys={["Alt", "E"]} />}
            />
          </FilterItem>
          <FilterItem>
            <Button
              label="Refresh"
              color="black"
              onClick={refreshData}
              endIcon={<Shortcut keys={["Alt", "R"]} />}
            />
          </FilterItem>
        </FilterGroup>
      </div>
    </div>
  );
};

export default RetailerReportsSummary;
